// Defined by a discussion with the clients
const MOUNTING_SYSTEM_DEFAULT_MARGIN_METERS = 0.03;
const MOUNTING_SYSTEM_DEFAULT_SETBACK_METERS = 0.3;

export { MOUNTING_SYSTEM_DEFAULT_MARGIN_METERS, MOUNTING_SYSTEM_DEFAULT_SETBACK_METERS };
